import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderPresenceService {
  private headerPresent$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  constructor() { }

  /**
   * Define se o header está presente na aplicação
   * @param present true se o header está montado, false caso contrário
   */
  setHeaderPresent(present: boolean): void {
    this.headerPresent$.next(present);
  }

  /**
   * Retorna um Observable que emite o estado atual da presença do header
   * @returns Observable<boolean>
   */
  isHeaderPresent$(): Observable<boolean> {
    return this.headerPresent$.asObservable();
  }

  /**
   * Retorna o valor atual da presença do header de forma síncrona
   * @returns boolean
   */
  isHeaderPresentSync(): boolean {
    return this.headerPresent$.getValue();
  }
}
